import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import './globalStyles.css';
import { App } from './app';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import { GetTheme } from '@client/theme';
import { i18n, AlertProvider, AmplitudeProvider } from '@renderer/provider';

import { ErrorBoundary } from '@client/routes/errorBoundary';
import { HelmetProvider } from 'react-helmet-async';
import { Spinner } from '@client/components';

const rootElement = document.getElementById('root');

function BootstrapApp() {
  const [theme, setTheme] = useState<any>(null);

  useEffect(() => {
    const init = async () => {
      try {
        const loadedTheme = await GetTheme();
        setTheme(loadedTheme);
      } catch (err) {
        console.error('Failed to load theme:', err);
      }
    };
    init();
  }, []);

  if (!theme) return <Spinner />;

  return (
    <StrictMode>
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AmplitudeProvider>
              <AlertProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </AlertProvider>
            </AmplitudeProvider>
          </ThemeProvider>
        </I18nextProvider>
      </HelmetProvider>
    </StrictMode>
  );
}

if (rootElement) {
  createRoot(rootElement).render(<BootstrapApp />);
} else {
  console.error('Root element not found');
}
